export const GoogleMapApiConfig = 'AIzaSyAkQRdZalj_OAH5DuyRzUSLZ5wKg4veibw';